var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('iframe',{staticClass:"child",style:({width: _vm.width, height:_vm.height}),attrs:{"src":"https://h5.ultranaira.com/#/privacy_policy","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }